if (!customElements.get('featured-brands')) {
  class FeaturedBrands extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.featured-brands__grid',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.columnsDesktop = parseInt(this.dataset.columnsDesktop, 10) || 5;
      this.columnsMobile = parseInt(this.dataset.columnsMobile, 10) || 2;

      this.sliderInstance = null;
      this.init();
    }

    init() {
      if (!this.sliderWrapper || !window.FoxTheme || !window.FoxTheme.Carousel) return;

      const slidesCount = this.querySelectorAll('.featured-brands__item').length;
      if (slidesCount === 0) return;

      this.classList.add('swiper');

      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Mousewheel, FoxTheme.Swiper.A11y],
        slidesPerView: this.columnsMobile,
        slidesPerGroup: this.columnsMobile,
        spaceBetween: 0,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        loop: false,
        threshold: 2,
        watchOverflow: true,
        a11y: {
          enabled: true,
        },
        mousewheel: {
          enabled: false,
        },
        breakpoints: {
          768: {
            slidesPerView: Math.min(this.columnsDesktop, 4),
            slidesPerGroup: Math.min(this.columnsDesktop, 4),
          },
          1024: {
            slidesPerView: this.columnsDesktop,
            slidesPerGroup: this.columnsDesktop,
          },
        },
      };

      this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId !== this.sectionId) return;
          const index = Number(e.detail.target.dataset.index);
          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.slideTo(index);
          }
        });
      }
    }

    disconnectedCallback() {
      if (this.sliderInstance && this.sliderInstance.slider) {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = null;
      }
    }
  }

  customElements.define('featured-brands', FeaturedBrands);
}
